import { ApiClient } from "../../api/ApiClient";

const apiBaseUrl = process.env.REACT_APP_API_DOMAIN;

export const createPaymentIntent = async (url, filingId) => {
  const csrfToken = await ApiClient.getCsrfToken();
  const response = fetch(`${apiBaseUrl}/${url}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    credentials: "include",
    body: JSON.stringify({ service_id: filingId, content_type: 'tax.taxfiling' }),
  });

  return response;
};

export const fetchPaymentIntentFiling = async (url, filingId) => {
  const csrfToken = await ApiClient.getCsrfToken();
  const response = fetch(`${apiBaseUrl}/${url}/${filingId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    credentials: "include",
  });

  return response;
};

export const fetchPaymentHistory = async (starting_after = null) => {
  const csrfToken = await ApiClient.getCsrfToken();
  
  // Build query parameters (limit is handled server-side)
  const queryParams = new URLSearchParams();
  if (starting_after) {
    queryParams.append('starting_after', starting_after);
  }
  
  const queryString = queryParams.toString();
  const url = queryString 
    ? `${apiBaseUrl}/payments/payment-intent-filing?${queryString}`
    : `${apiBaseUrl}/payments/payment-intent-filing`;
  
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    credentials: "include",
  });

  return response;
};

export const fetchPayoutHistory = async (starting_after = null) => {
  const csrfToken = await ApiClient.getCsrfToken();
  
  // Build query parameters (limit is handled server-side)
  const queryParams = new URLSearchParams();
  if (starting_after) {
    queryParams.append('starting_after', starting_after);
  }
  
  const queryString = queryParams.toString();
  const url = queryString 
    ? `${apiBaseUrl}/payments/platform-payouts?${queryString}`
    : `${apiBaseUrl}/payments/platform-payouts`;
  
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    credentials: "include",
  });

  return response;
};

export const fetchNextPayout = async () => {
  const csrfToken = await ApiClient.getCsrfToken();
  
  const url = `${apiBaseUrl}/payments/balance-payout`;
  
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    credentials: "include",
  });

  return response;
};